import React from "react"
import { Chip } from "material-ui"
import autobind from "class-autobind"
import AddTemplateDialogForChip from "./AddTemplateDialogForChip"
import { IScheduleTemplate, IScheduleDocument } from "../../../../../models"
import strings from "../../../../../localization/strings"
interface IProps {
  overrideHierarchy: boolean
  hierarchyId: string
  jobId: string
  selectedTemplate: IScheduleTemplate | IScheduleDocument
  handleSelectTemplate(selectedTemplate: IScheduleTemplate | IScheduleDocument): void
}
interface IState {
  openAddTemplateDialog: boolean
}

export default class ScheduleTemplateAndMasterScheduleChip extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      openAddTemplateDialog: false,
    }
    autobind(this)
  }

  render() {
    const isScheduleTemplate = this.props.selectedTemplate && (this.props.selectedTemplate as IScheduleTemplate).PatternTemplates ? true : false
    const templateName = this.props.selectedTemplate && `${this.props.selectedTemplate.Name}`
    return (
      <div style={{ marginTop: 10, marginBottom: 10, display: "inline-block", position: "relative" }}>
        <div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.298)" }}>
          {strings.Template}
        </div>
        <Chip
          data-intercom-target={"Select-ScheduleTemplate"}
          style={{ cursor: "pointer", marginTop: 2, height: 35 }}
          onClick={() => this.setState({ openAddTemplateDialog: true })}
          labelStyle={{ position: "inherit", top: 2 }}
        >
          <div style={{ display: "flex" }} title={templateName}>
            <div className="TextOverflow">
              {this.props.selectedTemplate ?
                [
                  <span key="group" style={{ fontWeight: 600, marginRight: 10 }}>{isScheduleTemplate ? strings.Schedule_Template : strings.Master_schedule}</span>,
                  <span key="name">{templateName}</span>
                ] :
                strings.Select_Template
              }
            </div>
          </div>
        </Chip>
        {this.state.openAddTemplateDialog &&
          <AddTemplateDialogForChip
            overrideHierarchy={this.props.overrideHierarchy}
            hierarchyId={this.props.hierarchyId}
            jobId={this.props.jobId}
            handleClose={() => this.setState({ openAddTemplateDialog: false })}
            handleSelectTemplate={selectedTemplate => {
              this.setState({ openAddTemplateDialog: false })
              selectedTemplate &&
                this.props.handleSelectTemplate(selectedTemplate)
            }}
          />
        }
      </div>
    )
  }
}